import { combineReducers } from '@reduxjs/toolkit';
import { adminDocumentsReducer } from './adminDocuments/reducer';
import { postGenerateLinkSlice } from './slices';
import { finalizeDocumentSlice } from '../../documents/slices';

export const documentsReducer = combineReducers({
  postGenerateLink: postGenerateLinkSlice.reducer,
  adminDocuments: adminDocumentsReducer.reducer,
  finalizeDocument: finalizeDocumentSlice.reducer,
});
